export const USER_STATUS_PENDING_EMAIL_VERIFICATION = 'PENDING_EMAIL_VERIFICATION';
export const USER_STATUS_ACTIVE = 'ACTIVE';
export const USER_STATUS_DEACTIVATED = 'DEACTIVATED';

export const MFA_STATUS_NOT_ENABLED = 'NOT_ENABLED';
export const MFA_STATUS_ENABLED = 'ENABLED';
export const MFA_STATUS_UNKNOWN = 'UNKNOWN';
